/**
 * https://github.com/robrogers3/vue-single-select
 */
import Vue from 'vue';
import VueSingleSelect from "vue-single-select";
Vue.component('vue-single-select', VueSingleSelect);